import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import * as _ from 'lodash'; // Import Lodash for deep comparison
import { StockService } from 'src/app/stock.service';
import { OrderItemDetailsDTO } from 'src/app/domain/OrderItemDetails';
import { StockItemDTO } from 'src/app/domain/stock';
@Component({
  selector: 'app-order-item-details',
  templateUrl: './order-item-details.component.html',
  styleUrls: ['./order-item-details.component.scss'],
  providers: [MessageService],
})
export class OrderItemDetailsComponent {
  orderItemDetails: OrderItemDetailsDTO;


  stockItem: StockItemDTO = {
    id: 0,
    serialNumber: '',
    itemPurchaseDate: null,
    itemExpiryDate: null,
    grDate: null,
    stockId: 0,
    orderNumber: 0,
    opportunityName: '',
    customerName: '',
    sellingPrice: 0,
    costPrice: 0,
    productCategory: '',
    productType: '',
    productItem: '',
    isLicense: false,
    customerNumber: '',
    deliveryTicket: {
      title: '',
      createdDate: '',
      deliveryDate: '',
      receiverName: '',
      receiverContact: '',
      deliveredBy: '',
      deliveryText: '',
      masterOrderId: 0,
      movementState: '',
      deliveredQty: 0,
      stockItemIds: [],
    },
    partNumber: '',
    itemDescription: '',
    customerId: 0,
  };
  constructor(
    private router: Router,
    private stockService: StockService,
    private messageService: MessageService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.stockItem = navigation.extras.state['data'] || {
        id: 0,
        serialNumber: '',
        itemPurchaseDate: null,
        itemExpiryDate: null,
        stockId: 0,
        orderNumber: 0,
        opportunityName: '',
        customerName: '',
        sellingPrice: 0,
        costPrice: 0,
        productCategory: '',
        productType: '',
        productItem: '',
        salesOrderItemNumber: '',
        salesOrderNumber: '',
        isLicense: false,
        deliveryTicket: {
          title: '',
          createdDate: '',
          deliveryDate: '',
          receiverName: '',
          receiverContact: '',
          deliveredBy: '',
          deliveryText: '',
          masterOrderId: 0,
          movementState: '',
          deliveredQty: 0,
          stockItemIds: [],
        },
        customerNumber: '',
        partNumber: '',
        itemDescription: '',
        customerId: 0,
      };
      // Ensure deliveryTicket is initialized as an object
      this.stockItem.deliveryTicket = this.stockItem.deliveryTicket || {
        title: '',
        createdDate: '',
        deliveryDate: '',
        receiverName: '',
        receiverContact: '',
        deliveredBy: '',
        deliveryText: '',
        masterOrderId: 0,
        movementState: '',
        deliveredQty: 0,
        stockItemIds: [],
      };
      this.orderItemDetails = {
        id: this.stockItem.id || null,
        serialNumber: this.stockItem.serialNumber || '',
        coverageFromDate: this.stockItem.itemPurchaseDate || null,
        coverageToDate: this.stockItem.itemExpiryDate || null,
        materialDescription: this.stockItem.itemDescription || '',
      };
    } else {
      this.stockItem = {
        id: 0,
        serialNumber: '',
        itemPurchaseDate: null,
        itemExpiryDate: null,
        grDate: null,
        stockId: 0,
        orderNumber: 0,
        opportunityName: '',
        customerName: '',
        sellingPrice: 0,
        costPrice: 0,
        productCategory: '',
        productType: '',
        productItem: '',
        salesOrderItemNumber: '',
        salesOrderNumber: '',
        isLicense: false,
        deliveryTicket: {
          title: '',
          createdDate: '',
          deliveryDate: '',
          receiverName: '',
          receiverContact: '',
          deliveredBy: '',
          deliveryText: '',
          masterOrderId: 0,
          movementState: '',
          deliveredQty: 0,
          stockItemIds: [],
        },
        customerNumber: '',
        partNumber: '',
        itemDescription: '',
        customerId: 0,
      };
      this.orderItemDetails = {
        id: null,
        serialNumber: '',
        coverageFromDate: null,
        coverageToDate: null,
        materialDescription: '',
      };
    }
  }

  saveChanges() {


      const { coverageFromDate, coverageToDate, serialNumber } = this.orderItemDetails;

      // Check if serial number is filled
      if (!serialNumber) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Serial number is required.',
        });
        return;
      }

      // Validate coverage dates
      if ((coverageFromDate && !coverageToDate) || (coverageToDate && !coverageFromDate)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Both Coverage From and Coverage To must be filled.',
        });
        return;
      }

    this.stockService.updateOrderItemDetails(this.orderItemDetails).subscribe(
      (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Order item details updated successfully',
        });
        // this.navigateToCustomerOrdersPage();
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update order item details',
        });
      }
    );
  }
  navigateToCustomerOrdersPage() {
    this.router.navigate(['/customer-orders'], {
      queryParams: { customerId: this.stockItem.customerId },
      state: { customerId: this.stockItem.customerId },
    });
    // console.log('Navigating to customer orders page');
  }
}
